import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationHdrModel } from '../../../../../models/aggregates/asv/asv-consultation-hdr.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../api-services';

@Injectable({
  providedIn: 'root'
})
export class AsvConsultationHdrService extends BaseApiTemplateService<AsvConsultationHdrModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation-hdrs';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-hdrs/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-hdrs/backoffice-ep';
        this.httpClient = http;
      }

    public createTemp(payload: AsvConsultationHdrModel, apiVisa: ApiVisa) {
        let apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation-hdrs/backoffice-ep/temp';
        return this.httpClient.post<ApiResponseModel<any>>(
            apiUrl,
            payload,
            this.getHttpHeader(apiVisa)
        );
    }

}
